import createLeadFieldSelect from "./createLeadFieldSelect";

export default createLeadFieldSelect("/leads/all_cities", {
  displayName: "CitySelect",
  defaultPlaceholder: "Select Cities",
});
